import { Group } from 'three';

/**
 * 不参与业务拾取、离线保存的选择显示组。
 * 每个正式投影父级拥有一个单位变换分组，使实例浮点矩阵计算顺序保持不变。
 */
export class ImportedModelSelectionGroup extends Group {
    /** 创建只管理派生显示的单位变换组。 */
    public constructor() {
        super();
        this.name = '__imported_model_tree_selection__';
        // 预热前也可能创建空选择组；默认隐藏，只有实际选择或单帧预热才开放遍历。
        this.visible = false;
        this.matrixAutoUpdate = false;
        // 新组虽然局部矩阵为单位矩阵，首次仍须继承可能非单位的父世界矩阵。
        this.matrixWorldNeedsUpdate = true;
        this.userData.skipSelection = true;
        this.userData.skipSelectionSubtree = true;
        this.userData.isImportedModelOverlay = true;
    }
}
